var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0.329484663%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B816",
    offset: "99.934016%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beispiel",
    transform: "translate(-690.000000, -196.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715,196 C728.807119,196 740,207.192881 740,221 C740,234.807119 728.807119,246 715,246 C701.192881,246 690,234.807119 690,221 C690,207.192881 701.192881,196 715,196 Z M727.442308,210 L702.762821,210 L702.618248,210.005844 C701.712332,210.079389 701,210.837964 701,211.762821 L701,211.762821 L701,229.391026 L701.005844,229.535598 C701.079389,230.441514 701.837964,231.153846 702.762821,231.153846 L702.762821,231.153846 L727.442308,231.153846 L727.58688,231.148002 C728.492796,231.074457 729.205128,230.315882 729.205128,229.391026 L729.205128,229.391026 L729.205128,211.762821 L729.199284,211.618248 C729.125739,210.712332 728.367164,210 727.442308,210 L727.442308,210 Z M725.679487,213.525641 L725.679487,227.628205 L704.525641,227.628205 L704.525641,213.525641 L725.679487,213.525641 Z M712.282051,215.641026 L712.282051,225.512821 L720.74359,220.574503 L712.282051,215.641026 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialVideo);
export default __webpack_public_path__ + "static/media/special_video.ad9b03c4081091d2297c2b73ca0077a5.svg";
export { ForwardRef as ReactComponent };